module.exports = __webpack_public_path__ + "img/27.ee6bdd65.png";